import { useContext } from 'react'
import { styled } from '../../../../lib/stitches'
import { gray15, gray4, gray8 } from '../../../platform/color'
import { UploadModalContext } from './index'

const StyledStepNav = styled('nav', {
  display: 'flex',
  gap: '36px',
  paddingTop: '16px',
  paddingBottom: '24px',
  marginBottom: '24px',
  borderBottomWidth: '1px',
  borderBottomColor: gray4,
  borderBottomStyle: 'solid'
})

const StyledStepNavItem = styled('div', {
  display: 'flex',
  alignItems: 'center',
  fontSize: '14px',
  '&:before': {
    marginRight: '10px',
    borderRadius: '4px',
    width: '22px',
    height: '22px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '12px',
    fontWeight: 700
  }
})

export const Title = styled('h1', {
  fontSize: '22px',
  lineHeight: '28px',
  fontWeight: 700,
  color: gray15,
  marginBottom: '8px'
})

const UploadModalNavigation = () => {
  const { steps, stepIndex, title } = useContext(UploadModalContext)

  return (
    <>
      <Title>{title}</Title>
      <StyledStepNav>
        {steps
          .filter((step) => step.showNavigation)
          .map((step, index) => {
            const isCurrentStep = index === stepIndex

            return (
              <StyledStepNavItem
                key={step.name}
                css={{
                  color: isCurrentStep ? gray15 : gray8,
                  '&:before': {
                    content: `${index + 1}`,
                    backgroundColor: isCurrentStep ? '#4992E8' : gray4,
                    color: isCurrentStep ? 'white' : gray8
                  }
                }}
              >
                {step.name}
              </StyledStepNavItem>
            )
          })}
      </StyledStepNav>
    </>
  )
}

export default UploadModalNavigation
